<template>
  <div>
    <el-group-title title="">
      <template slot="groupTitle">
        <el-table
          :header-cell-style="{ background: '#ffffff', color: '#4A4A4A' }"
          :data="tableData"
          style="width: 100%"
          row-key="id"
          border
          class="multifunctional-table dic-sub-table-style01"
        >
          <!-- report multi-header  -->
          <el-table-column
            prop=""
            type="index"
            label="序号"
            :width="commonTableWidth.serialNoWidth"
          />
          <el-table-column
            prop="assessTaskCode"
            label="任务编号"
            :width="taskColWidth.taskCode"
          />
          <el-table-column
            prop="assessTaskName"
            label="任务名称"
            :width="taskColWidth.taskName"
          />
          <el-table-column
            prop="orgRecommendName"
            label="任务单位"
            :width="commonTableWidth.unitName"
          />
          <el-table-column
            prop="createTime"
            label="编制日期"
            :width="commonTableWidth.dateWidth"
          />
          <el-table-column prop="sumSupcent" label="总分数" />
          <el-table-column label="基础评价分数" align="center">
            <el-table-column
              prop="priceCompetityScore"
              label="价格竞争力"
              width="100"
            />
            <el-table-column prop="qualityScore" label="质量" />
            <el-table-column
              prop="deliveryRateScore"
              label="准时交货率"
              width="100"
            />
            <el-table-column prop="basedScore" label="小计" />
          </el-table-column>
          <el-table-column label="运营评价分数" align="center">
            <el-table-column prop="sincerityScore" label="诚信合作" />
            <el-table-column prop="superviseScore" label="管理体系" />
            <el-table-column prop="competenceScore" label="人员能力" />
            <el-table-column prop="serviceScore" label="服务水平" />
            <el-table-column prop="operateScore" label="小计" />
          </el-table-column>
          <el-table-column label="风险评价分数" align="center">
            <el-table-column prop="financialScore" label="财务风险" />
            <el-table-column prop="preventionScore" label="风险防控" />
            <el-table-column prop="riskScore" label="小计" />
          </el-table-column>
        </el-table>
      </template>
    </el-group-title>
  </div>
</template>

<script>
import { commonTableWidth, taskColWidth } from "@/setting/setting";
export default {
  name: "link-info.vue",
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      commonTableWidth: commonTableWidth,
      taskColWidth: taskColWidth
    };
  }
};
</script>

<style scoped></style>
